function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutlook = function SvgOutlook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "60 90.4 570.02 539.67"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 9.989,
    x2: 30.932,
    y1: 22.365,
    y2: 9.375,
    gradientTransform: "scale(15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20a7fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#3bd5ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c4b0ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 17.197,
    x2: 28.856,
    y1: 26.794,
    y2: 8.126,
    gradientTransform: "scale(15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#165ad9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    style: {
      stopColor: "#1880e5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8587ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 25.701,
    x2: 12.756,
    y1: 27.048,
    y2: 16.501,
    gradientTransform: "scale(15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#448aff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    style: {
      stopColor: "#0032b1",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 24.053,
    x2: 44.51,
    y1: 31.11,
    y2: 18.018,
    gradientTransform: "scale(15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1a43a6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    style: {
      stopColor: "#2052cb",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5f20cb",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 29.828,
    x2: 17.397,
    y1: 30.327,
    y2: 19.571,
    gradientTransform: "scale(15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0045b9",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#0d1f69",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 41.998,
    x2: 23.852,
    y1: 29.943,
    y2: 29.943,
    gradientTransform: "scale(15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4dc4ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    style: {
      stopColor: "#0fafff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 3.458,
    x2: 20.929,
    y1: 37.872,
    y2: 37.86,
    gradientTransform: "scale(15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    style: {
      stopColor: "#6ce0ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    style: {
      stopColor: "#50d5ff",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    gradientTransform: "matrix(0 -405.04051 438.393 0 359.92 102.475)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    style: {
      stopColor: "#275ff0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    style: {
      stopColor: "#002177",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    gradientTransform: "rotate(-45 897.061 -224.265)scale(173.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    style: {
      stopColor: "#0060d1",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    style: {
      stopColor: "#0383f1",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    gradientTransform: "matrix(357.40702 -468.44593 423.59457 323.18709 159.471 697.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    style: {
      stopColor: "#f4a7f7",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f4a7f7",
      stopOpacity: 0.501961
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    gradientTransform: "matrix(-170.86087 259.7254 -674.01813 -443.40415 278.562 412.979)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#49deff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    style: {
      stopColor: "#29c3ff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    gradientTransform: "rotate(46.924 -378.504 245.25)scale(315.927)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    style: {
      stopColor: "#0091ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    style: {
      stopColor: "#183dad",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0,
    cy: 0,
    r: 1,
    fx: 0,
    fy: 0,
    gradientTransform: "matrix(0 168 -193.782 0 180 491.159)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    style: {
      stopColor: "#0fa5f7",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#74c6ff",
      stopOpacity: 0.501961
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m463.984 140.145-344.347 218.27-29.614-46.72v-40.257a43.26 43.26 0 0 1 19.72-36.293L309.91 105.258c30.496-19.79 69.777-19.793 100.277-.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.102 103.34a91 91 0 0 1 3.082 1.914l156.214 101.332-387.335 245.52-59.438-93.77L403.895 177.8c26.925-17.102 28.105-55.57 3.207-74.461m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.102 103.34a91 91 0 0 1 3.082 1.914l156.214 101.332-387.335 245.52-59.438-93.77L403.895 177.8c26.925-17.102 28.105-55.57 3.207-74.461m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 498.988 179.066 452.11 507.63 243.836c27.672-17.54 27.601-57.938-.133-75.379l-1.48-.93 4.261 2.649 99.996 64.867a43.26 43.26 0 0 1 19.723 36.3v38.962Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 498.988 179.066 452.11 507.63 243.836c27.672-17.54 27.601-57.938-.133-75.379l-1.48-.93 4.261 2.649 99.996 64.867a43.26 43.26 0 0 1 19.723 36.3v38.962Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.188 105.25c-30.5-19.785-69.782-19.781-100.282.008L109.742 235.145a43.26 43.26 0 0 0-19.719 36.292v1.97a44.48 44.48 0 0 0 20.735 36.16l248.887 156.91L609.16 309.805a44.47 44.47 0 0 0 20.824-37.664v38.168l.008-38.965a43.28 43.28 0 0 0-19.722-36.301Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.77 630.05h220.449c51.777 0 93.75-41.972 93.75-93.75V272.14a44.48 44.48 0 0 1-20.82 37.665l-327.907 205.89a60.71 60.71 0 0 0-28.422 51.414c.004 34.762 28.184 62.942 62.95 62.942m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.77 630.05h220.449c51.777 0 93.75-41.972 93.75-93.75V272.14a44.48 44.48 0 0 1-20.82 37.665l-327.907 205.89a60.71 60.71 0 0 0-28.422 51.414c.004 34.762 28.184 62.942 62.95 62.942m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.77 630.05h220.449c51.777 0 93.75-41.972 93.75-93.75V272.14a44.48 44.48 0 0 1-20.82 37.665l-327.907 205.89a60.71 60.71 0 0 0-28.422 51.414c.004 34.762 28.184 62.942 62.95 62.942m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.402 630.035H183.738c-51.777 0-93.75-41.972-93.75-93.75v-264.34a44.47 44.47 0 0 0 20.754 37.621l327.582 206.52a61.74 61.74 0 0 1 28.809 52.226c-.004 34.09-27.64 61.723-61.73 61.723m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.402 630.035H183.738c-51.777 0-93.75-41.972-93.75-93.75v-264.34a44.47 44.47 0 0 0 20.754 37.621l327.582 206.52a61.74 61.74 0 0 1 28.809 52.226c-.004 34.09-27.64 61.723-61.73 61.723m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75 345h142.5c26.926 0 48.75 21.824 48.75 48.75v142.5c0 26.926-21.824 48.75-48.75 48.75h-142.5C81.824 585 60 563.176 60 536.25v-142.5C60 366.824 81.824 345 108.75 345m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75 345h142.5c26.926 0 48.75 21.824 48.75 48.75v142.5c0 26.926-21.824 48.75-48.75 48.75h-142.5C81.824 585 60 563.176 60 536.25v-142.5C60 366.824 81.824 345 108.75 345m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.387 534q-29.77-.001-48.875-18.625-19.11-18.622-19.11-48.605c0-21.11 6.465-38.18 19.395-51.22Q150.195 396 181.594 396q29.67 0 48.297 18.715c12.484 12.476 18.726 28.93 18.726 49.351 0 20.985-6.469 37.899-19.398 50.75Q209.919 534 179.387 534m.574-26.352q16.225 0 26.117-11.082c6.594-7.386 9.89-17.664 9.89-30.824q-.001-20.577-9.6-32.031-9.605-11.454-25.638-11.453-16.518 0-26.597 11.824-10.083 11.736-10.082 31.102 0 19.652 10.082 31.101 10.078 11.362 25.828 11.363m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.332 535.848q-29.655.001-48.691-19.13-19.034-19.131-19.036-49.929 0-32.525 19.325-52.61 19.324-20.09 50.601-20.09 29.555.001 48.114 19.227 18.654 19.23 18.652 50.7c0 21.55-6.442 38.93-19.32 52.129q-19.23 19.704-49.645 19.703m.57-27.067c10.778 0 19.453-3.797 26.02-11.383q9.853-11.384 9.851-31.664 0-21.138-9.562-32.902-9.567-11.766-25.54-11.766-16.457-.002-26.5 12.149c-6.694 8.031-10.042 18.683-10.042 31.945q0 20.185 10.043 31.95 10.043 11.67 25.73 11.671m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    }
  }));
};
export default SvgOutlook;